import React from 'react';
import './Profile.css';

function Profile() {
  return (
    <div className="profile-container">
      <img src="/bene.png" alt="Profile" className="profile-image" />
      <p className="username">라끌로</p>
    </div>
  );
}

export default Profile;
